import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import firebase from 'firebase/app';
import '@firebase/firestore';
import moment from 'moment';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'moment/locale/fi';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

//moment.locale('fi');
Vue.prototype.$moment = moment;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;
/*
Note: These are not private keys
*/
const firebaseConfig = {
  apiKey: 'AIzaSyBCunWV9jh8XabfbFY044MG1NVwoCnoNiY',
  authDomain: 'gs-flow.firebaseapp.com',
  databaseURL: 'https://gs-flow.firebaseio.com',
  projectId: 'gs-flow',
  storageBucket: 'gs-flow.appspot.com',
  messagingSenderId: '276897084449',
  appId: '1:276897084449:web:6863fe4ac676415c045f60',
};

firebase.initializeApp(firebaseConfig);

// Read app here to variable because if we refresh
// the page when signed in it always goes to Login route
// Reason: (firebase.auth() takes some time)
let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
});
